import { Actions } from '../actions/userInfo';
import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';
import { IUserInfo } from '../interfaces/userInfo';

export type State = DeepReadonly<{
  isFetching: boolean;
  userInfo: IUserInfo | null;
  error: AxiosError | null;
}>;

export const initialState: State = {
  isFetching: false,
  userInfo: null,
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_USERINFO_REQUEST':
      return {
        ...state,
        isFetching: true
      };
    case 'FETCH_USERINFO_SUCCESS':
      return {
        isFetching: false,
        userInfo: action.payload,
        error: null
      };
    case 'FETCH_USERINFO_FAILURE':
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
